<div
  id="visionboard-item-selection-panel"
  class="visionboard-item-selection-panel"
  [class.has-item-filter-scroller]="scrollerLoaded && itemFilterScroller.loaded"
>
  <div class="top-controls">
    <span class="title">{{ subCategoryName }}</span>
    <button
      mat-icon-button
      class="hide-button"
      (click)="onCloseButtonClick()"
    >
      <mat-icon svgIcon="chevron_left"></mat-icon>
    </button>
  </div>
  <app-vendor-banner
    class="preferred-vendor"
    *ngIf="preferredVendor"
    [compact]="true"
    [vendor]="preferredVendor"
  ></app-vendor-banner>
  <div class="search-and-filters">
    <div class="search-and-filter-button">
      <app-visionboard-item-search-bar class="search"></app-visionboard-item-search-bar>
      <app-search-filters
        class="filters"
        height="36px"
      ></app-search-filters>
    </div>
    <app-visionboard-item-filter-scroller
      #itemFilterScroller
      (onLoaded)="onScrollerLoaded()"
    ></app-visionboard-item-filter-scroller>
  </div>

  <app-visionboard-item-search-results
    class="results"
    (paged)="onItemResultsPaged()"
    [source]="source"
    [disableDrag]="disableDrag"
    [forceVisionboardItemAddRemoveButton]="forceVisionboardItemAddRemoveButton"
    [itemCustomAddRemoveTemplate]="itemCustomAddRemoveTemplate"
  ></app-visionboard-item-search-results>
</div>
